/// <reference path="../../_ext/Editors/ItemEditorDialog.ts" />
namespace TabAurous.ProductDevelopment {

    @Serenity.Decorators.registerClass() 
    export class PDQuotationItemsForPD extends _Ext.ItemEditorDialog<PDQuotationItemsRow> {
        protected getFormKey() { return PDQuotationItemsForm.formKey; }
        protected getIdProperty() { return PDQuotationItemsRow.idProperty; }
        protected getLocalTextPrefix() { return PDQuotationItemsRow.localTextPrefix; }
        protected getNameProperty() { return PDQuotationItemsRow.nameProperty; }
        protected getService() { return PDQuotationItemsService.baseUrl; } 
        protected useViewMode() { return true; }
        public form = new PDQuotationItemsForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public TransDate: Date;
        public newLineNo: number;
        public Totals: number;
        public HasBom: boolean = true;
        public ItemMaster: PDQuotationItemsDialog;
        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 450;
            q.initBOMEditor(this, this.form.BOMDetails, Config);
            q.initLaborEditor(this, this.form.LaborDetails, Config);
            q.HideDialogToolbar(this.element);
            //Make grid full width
            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorLabel(this.form.ImageName);
            q.hideEditorLabel(this.form.LaborDetails);
            //Set Numeric Fields as Right Align
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.DiamondAmount);
            q.setTextRightAlign(this.form.DiamondPieces);
            q.setTextRightAlign(this.form.DiamondWeight);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.OtherAmount);
            q.setTextRightAlign(this.form.OtherWeight);
            q.setTextRightAlign(this.form.OtherPieces);
            q.setTextRightAlign(this.form.UnitRate);
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.StonePieces);
            q.setTextRightAlign(this.form.StoneWeight);
            q.setTextRightAlign(this.form.WstPer);
            q.setTextRightAlign(this.form.WstWt);
            q.setTextRightAlign(this.form.UnitLabour);
        }


        protected onDialogOpen() {
            super.onDialogOpen();
              
        }
        public getToolbarButtons() {
            return [];
        }
 
    }
}